import { Button, CircularProgress, HStack, ScaleFade, Skeleton, Text, Tooltip } from '@chakra-ui/react'
import { useExposureCompanyCategories } from '../../services/exposure-service'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'

const CompanyExposure = ({ id }: { id: string }) => {
	const { t } = useTranslation()

	const [isMutating, setIsMutating] = useState(false)

	const refreshExposure = () => {
		setIsMutating(true)
	}

	const {
		data: {
			total: { total },
			lastUpdated,
		},
		isLoading,
	} = useExposureCompanyCategories(id, isMutating)

	const dateString = lastUpdated
		? new Date(lastUpdated)
				.toLocaleDateString('he-IL', {
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
					hour: '2-digit',
					minute: '2-digit',
				})
				.replaceAll('.', '/')
				.split(', ')
				.reverse()
				.join(' ')
		: ''

	const navigate = useNavigate()

	return !isNaN(+total) ? (
		<div className='flex gap-2 items-center'>
			<ScaleFade
				onClick={() => navigate(`/admin/exposure/${id}`)}
				initialScale={0}
				in
			>
				<HStack spacing={1}>
					<Text
						textAlign={'end'}
						width='50px'
					>
						{(total * 100).toFixed(0)}%
					</Text>
					<CircularProgress
						value={total * 100}
						size='40px'
						thickness='10px'
						color={
							total * 100 < 25
								? 'red.500'
								: total * 100 < 50
								? 'yellow.300'
								: total * 100 < 75
								? '#F6A860'
								: '#3FB2D2'
						}
					/>
				</HStack>
			</ScaleFade>
			<Tooltip
				label={
					<>
						{t('companies.lastUpdated')} {dateString}
					</>
				}
			>
				<Button
					color={'#3FB2D2'}
					bg='transparent'
					onClick={refreshExposure}
					isLoading={isLoading}
				>
					<svg
						width='30px'
						height='30px'
						viewBox='0 0 50 50'
						xmlns='http://www.w3.org/2000/svg'
					>
						<path d='M25 38c-7.2 0-13-5.8-13-13 0-3.2 1.2-6.2 3.3-8.6l1.5 1.3C15 19.7 14 22.3 14 25c0 6.1 4.9 11 11 11 1.6 0 3.1-.3 4.6-1l.8 1.8c-1.7.8-3.5 1.2-5.4 1.2z' />
						<path d='M34.7 33.7l-1.5-1.3c1.8-2 2.8-4.6 2.8-7.3 0-6.1-4.9-11-11-11-1.6 0-3.1.3-4.6 1l-.8-1.8c1.7-.8 3.5-1.2 5.4-1.2 7.2 0 13 5.8 13 13 0 3.1-1.2 6.2-3.3 8.6z' />
						<path d='M18 24h-2v-6h-6v-2h8z' />
						<path d='M40 34h-8v-8h2v6h6z' />
					</svg>
				</Button>
			</Tooltip>
		</div>
	) : (
		<Skeleton
			height='40px'
			width='40px'
			borderRadius='50%'
		/>
	)
}

export default CompanyExposure
